// extracted by mini-css-extract-plugin
export var col = "Promo-module--col--ON647";
export var content = "Promo-module--content--5PR9u";
export var extendBackgroundColor = "Promo-module--extend-background-color--6nKtR";
export var grid = "Promo-module--grid--NeQBw";
export var headline = "Promo-module--headline--9UBen";
export var hero = "Promo-module--hero--D3QSV";
export var subheadline = "Promo-module--subheadline--OoHLm";
export var wrapper = "Promo-module--wrapper--YwN9t";